import React, { useCallback, useMemo } from 'react';

import { ModalContent, ModalHeader } from '../../../components';
import { AddPaymentMethod } from '../../../components/AddPaymentMethod';
import { useModalStore } from '../../../stores';
import { EModalContent } from '../../../types';
import { EPaymentType } from '../types';

export const AddUsBankAccount = () => {
  const modalStore = useModalStore();

  const paymentTypes = useMemo(() => [EPaymentType.BANK_ACCOUNT], []);

  const handleBack = () => {
    modalStore.pop();
  };

  const handleSuccess = useCallback(() => {
    modalStore.navigate({ name: EModalContent.MY_WALLET });
  }, [modalStore]);

  return (
    <ModalContent
      header={
        <ModalHeader onClick={handleBack}>Add Us Bank Account</ModalHeader>
      }
    >
      <AddPaymentMethod
        showSetDefault
        paymentTypes={paymentTypes}
        onSuccess={handleSuccess}
      />
    </ModalContent>
  );
};
